<section class="end-chat-dialog">
  <div class="header">
    {{ message.title | translate }}
    <mat-icon class="close-button" (click)="close()">close</mat-icon>
  </div>
  <div class="body">
    <div class="body-start">
      <div *ngIf="!message.isChat && message.isPending" class="pending-badge">
        <mat-icon>pending_actions</mat-icon>
        {{ 'PENDING_TABULATION' | translate }}
      </div>
      <div *ngIf="!!message.titleTabulation && hasTabulations()" class="body-start__header">
        {{ message.titleTabulation | translate }}
      </div>
      <div *ngIf="!!message.chat?.channel?.channel?.name" class="body-start__row">
        <label class="">{{ 'CHANNEL' | translate }}</label>
        <div class="text-channel">
          <mat-icon style="font: message-box" [svgIcon]="iconChannel"> </mat-icon>
          <label>{{ message.chat?.channel?.channel?.name }}</label>
        </div>
      </div>
      <div *ngIf="!!message.chat?.contact?.name" class="body-start__row">
        <label class="">{{ 'CONTACT' | translate }}</label>
        <div>
          <label>{{ message.chat?.contact?.name }}</label>
        </div>
      </div>

      <ng-container *ngIf="!message.isChat && message.callInfo">
        <div *ngIf="!!message.callInfo.contactName" class="body-start__row">
          <label class="">{{ 'CONTACT' | translate }}</label>
          <div>
            <label>{{ message.callInfo.contactName }}</label>
          </div>
        </div>
        <div *ngIf="!!message.callInfo.number" class="body-start__row">
          <label class="">{{ 'PHONE_NUMBER' | translate }}</label>
          <div>
            <label>{{ message.callInfo.number | brPhoneFormat }}</label>
          </div>
        </div>
        <div *ngIf="!!message.callInfo.protocolNumber" class="body-start__row">
          <label class="">{{ 'PROTOCOL' | translate }}</label>
          <div>
            <label>{{ message.callInfo.protocolNumber }}</label>
          </div>
        </div>
        <div *ngIf="!!message.callInfo.duration" class="body-start__row">
          <label class="">{{ 'DURATION' | translate }}</label>
          <div>
            <label>{{ message.callInfo.duration }}</label>
          </div>
        </div>
      </ng-container>
    </div>

    <div
      class="form ds-full-flex"
      [ngClass]="{ scrolled: (treeNodesTabulation?.length ?? 0) > 1 }"
      *ngIf="hasTabulations()"
    >
      <div
        class="form__row form__row__full ds-form"
        [ngClass]="{ 'tabulation-card': (treeNodesTabulation?.length ?? 0) > 1 }"
        *ngFor="let item of treeNodesTabulation"
      >
        <div #treeSelect class="form__formfield tree-select">
          <div class="div-tabulation-channel">
            <div class="channel-label">
              <mat-icon style="font: message-box" *ngIf="item.iconChannel" [svgIcon]="item.iconChannel"> </mat-icon>
              <label class="form__formfield__label nowrap-ellipsis" *ngIf="item.channelType">
                {{ item.channelType + (item.channelNumber ? ' - ' + item.channelNumber : '') }}</label
              >
            </div>
            <label class="form__formfield__label nowrap-ellipsis font-14" *ngIf="item.chatsCount">{{
              '(' + item.chatsCount + ' ' + ('SELECTED_ATTENDANCES' | translate) + ')'
            }}</label>
          </div>
          <label class="form__formfield__label">{{ 'TABULATION' | translate }}</label>
          <p-treeSelect
            [id]="item.channelId + '-tabulation'"
            [filter]="true"
            [selectionMode]="tabulationSelectionMode"
            [options]="item.nodes"
            scrollHeight="200px"
            [(ngModel)]="item.selectedTabulations"
            [placeholder]="'SELECT_AN_OPTION' | translate"
            [emptyMessage]="textEmptyMessageFieldTabulation()"
          >
          </p-treeSelect>
        </div>
        <div class="form__formfield">
          <div class="form__formfield__label-row">
            <label class="form__formfield__label">{{ 'LABEL_COMMENTER' | translate }}</label>
            <button
              mat-button
              class="btn-generate-summary"
              type="button"
              [disabled]="generatingSummary"
              (click)="generateSummary(item)"
              matTooltip="{{ 'GENERATE_SUMMARY_TOOLTIP' | translate }}"
            >
              <mat-spinner *ngIf="generatingSummary" diameter="14"></mat-spinner>
              <mat-icon *ngIf="!generatingSummary">auto_awesome</mat-icon>
              {{ 'GENERATE_SUMMARY' | translate }}
            </button>
          </div>
          <textarea
            class="form__formfield__control"
            cols="10"
            [(ngModel)]="item.commenter"
            [disabled]="!hasTabulationSelected()"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <button mat-button (click)="close('cancel')">
      {{ 'CANCEL' | translate }}
    </button>
    <button mat-button class="btn-confirm" (click)="confirm()">
      {{ 'CONFIRM' | translate }}
    </button>
  </div>
</section>
